import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin, Select } from 'antd'
import TotalAndBar from '@/pages/Bmjy/components/components/TotalAndBar'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'

const tabsOptions = [
  {
    label: '按公司', 
    value: 'ags',
    api: null
  }, 
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

const gsTypeFilterOptions = [
  {
    label: '项目', 
    value: '项目',
  }, 
  {
    label: '非项目', 
    value: '非项目',
  }, 
  {
    label: '预开票', 
    value: '预开票',
  }, 
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const [data1, setData1] = useState([])
  const [data2, setData2] = useState([])
  const [data3, setData3] = useState([])
  const [gsType, setGsType] = useState([])
  const [tabType, setTabType] = useState('')
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    loadTime: updateTime
  })

  const mockData = useCallback(() => {
    const d1 = []
    const d2 = []
    const d3 = []
    for(let i=0; i<12; i++) {
      d1.push({
        "label": i+ 1 + "月",
        "value": Math.floor(Math.random()*100)
      })
      d2.push({
        "label": i+ 1 + "月",
        "value": Math.floor(Math.random()*100)
      })
      d3.push({
        "label": i+ 1 + "月",
        "value": Math.floor(Math.random()*100)
      })
    }
    setData1(d1)
    setData2(d2)
    setData3(d3)
  }, [])
  
  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.params.tab)
    mockData()
    if(!tabOption || !tabOption.api) {
      return
    }

    const res = await tabOption.api()
    if(res.success) {
      
    }
  }, [mockData])

  // 获取统计数据
  const getTotal = useCallback(async () => {
    
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData(), getTotal()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData, getTotal])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    setTabType(value.tab)
    getList()
  }, [getList])

  useEffect(() => {
    if(globalRef.current.loadTime !== updateTime) {
      globalRef.current.loadTime = updateTime
      getList()
    }
  }, [updateTime, getList])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <CardContainer
        tabs={tabsOptions}
        onTabChange={handleTabChange}
        title='月度统计'
        hasDepartSelect
        customFilter={
          tabType === 'ags' && <div className='ml-10'>
            <Select allowClear placeholder="请选择" maxTagCount={1} value={gsType} onChange={setGsType} size='small' mode="multiple" style={{minWidth: '100px'}}>
              {
                gsTypeFilterOptions.map(r => <Select.Option value={r.value} key={r.value}>{r.label}</Select.Option>)
              }
            </Select>
          </div>
        }
      >
        <TotalAndBar
          label1=''
          value1=""
          label2=''
          value2=""
          barData1={data1}
          barLabel1='本年'
          barData2={data2}
          barLabel2='上年'
          barData3={data3}
          barLabel3='未分配金额(万)'
          totalItems={[
            { label: '本年开票收入合计（万）', value: '229,262.16', primary: true },
            { label: '上年开票收入合计（万）', value: '336,623.98' },
            { label: '累计未分配合计（万）', value: '116,623.98' }
          ]}
        />
      </CardContainer>
    </Spin>
  )
}

export default Component
